<template>
  <div id="lm-wait">

<b-form-group
      id="imagen"
      label-cols-sm="2"
      label-cols-lg="1"
      label="Imagen"
      label-for="input-horizontal"
      class="align-items-center"
    >

    <LmImagen v-model="options" v-show="options.image" @fileRemoved="fileRemoved" />

    <LmUploadFiles
            label=""
            ref="lmUploadFiles"
            class="mb-2"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            v-show="!options.image"
        />

        </b-form-group>

    <b-form-group
      id="titulo-group"
      label-cols-sm="2"
      label-cols-lg="1"
      label="Título"
      label-for="input-horizontal"
      class="align-items-center my-3"
    >

  <!-- <b-form-input
        list="my-list-id"
        v-model="options.title"
    /> -->

   <LmTextInput list="my-list-id"
        v-model="options.title" class="mb-0" />

     <b-form-input
        list="my-list-id"
        v-model="options.idRandom"
        class="d-none"
    />

    </b-form-group>

    <b-form-group
      label-cols-sm="2"
      label-cols-lg="1"
      label="Subtítulo"
      label-for="input-horizontal"
      class="align-items-center my-3"
    >

  <!-- <b-form-input
        list="my-list-id"
        v-model="options.subtitle"
    /> -->

      <LmTextInput list="my-list-id"
        v-model="options.subtitle" class="mb-0"   />

    </b-form-group>

<b-form-group
      id="link"
      label-cols-sm="2"
      label-cols-lg="1"
      label="URL"
      label-for="input-horizontal"
      class="align-items-center my-3"
    >

    <!-- <b-form-input
        list="my-list-id"
        v-model="options.linkUrl"
    /> -->

      <LmTextInput list="my-list-id"
        v-model="options.linkUrl" class="mb-0"  />

    </b-form-group>

  </div>
</template>

<script>
import store from '@/store'

import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmImagen from '@/views/365/pages/elements/LmImagen'

export default {
  components: {
    LmSelect,
    LmImagen,
    LmTextInput,
    LmUploadFiles
  },
  data () {
    return {
      files: [],

      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        createImageThumbnails: false,
        previewsContainer: false,
        acceptedFiles: 'image/*'
      }
    }
  },
  props: {
    form: {
      dataList: ''
    },
    index: '',
    apiUrlPath: '',
    dataValue: '',
    options: {
      type: Object,
      idRandom: '',
      id: '',
      title: '',
      default: () => ({
        disabledOption: 'Seleccione una acción',
        content: []
      })
    }
  },
  methods: {

    setForm () {
      if (this.options.image) {
        const fileOption = {
          size: 100000
        }

        let urlImage = this.apiUrlPath + this.options.image
        this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, urlImage)
      }
    },
    fileCreated (file, response) {
      if (response) {
        setTimeout(() => {
          this.options.idRandom = Math.random()
        }, 1000
        )

        this.options.image = response.path
        this.options.imageOriginalName = response.originalname
        this.options.imageSize = this.bytesToSize(response.size)

        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileRemoved (file, error, xhr) {
      this.files = []
      this.$emit('fileRemovedImage')
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.lmRemoveAllFiles()
      this.$refs.lmUploadFiles.enable()
    },
    bytesToSize (bytes) {
      const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    }
  },
  mounted () {
    this.setForm()
  }
}
</script>
